import { devtoolsExchange } from '@urql/devtools'
import { initUrqlClient } from 'next-urql'
import type { ClientOptions } from 'urql'
import { cacheExchange, createClient, errorExchange, fetchExchange } from 'urql'

import urqlAuth from 'graphql/urql.auth'
import logger from 'lib/utils/logger'

const urqlConfig: ClientOptions = {
  url: process.env.NEXT_PUBLIC_GRAFBASE_GRAPHQL_API_URL as string,
  requestPolicy: 'cache-and-network',
  exchanges: []
}

export const urqlClient = createClient({
  ...urqlConfig,
  exchanges: [
    devtoolsExchange,
    urqlAuth,
    cacheExchange,
    fetchExchange,
    errorExchange({
      onError(error) {
        // Send graphql errors to Sentry
        if (error.graphQLErrors) {
          logger.error(error.graphQLErrors)
        }
      }
    })
  ]
})

export const getUrqlSsrClient = (authToken: string) => {
  return initUrqlClient(
    {
      ...urqlConfig,
      exchanges: [fetchExchange],
      fetchOptions: {
        headers: {
          authorization: `Bearer ${authToken}`
        }
      }
    },
    false
  )
}
